"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPAWAnalytics = void 0;
var NPAWAnalytics = /** @class */ (function () {
    function NPAWAnalytics(analyticsConfig) {
        this.analyticsConfig = analyticsConfig;
    }
    NPAWAnalytics.prototype.setup = function (videoAnalyticsConfig) {
        if (this.analyticsConfig.enable) {
            var youbora = require('youboralib');
            if (videoAnalyticsConfig.playerInstance && youbora) {
                this.plugin = new youbora.Plugin({ accountCode: this.analyticsConfig.API_KEY });
                youbora.Log.logLevel = youbora.Log.Level.DEBUG;
                this.plugin.setOptions({
                    'user.name': this.analyticsConfig.otherValues.username,
                    'app.name': 'Velvet',
                    'content.title': videoAnalyticsConfig.videoId,
                });
                var bitmovin8Adapter = require('youbora-adapter-bitmovin8');
                this.plugin.setAdapter(new bitmovin8Adapter(videoAnalyticsConfig.playerInstance));
                return this.plugin;
            }
        }
    };
    NPAWAnalytics.prototype.destroy = function () {
        this.plugin.removeAdapter();
    };
    return NPAWAnalytics;
}());
exports.NPAWAnalytics = NPAWAnalytics;
